/***********MultiStep*************/
$(document).ready(function() {
    $.validator.addMethod("usernameRegex", function(value, element) {
        return this.optional(element) || /^[a-zA-Z0-9]*$/i.test(value);
    }, "Username must contain only letters, numbers");
    $(".next").click(function(event) {

        var selectVal = $("#hear_about_us").val();
        if (selectVal == 'Please select one') {
            alert('please select one option');
            return false;
        }
        if ($('input#additional_hear').css('display') == 'block') {
            if (!$('input#additional_hear').val()) {
                alert('All fields are required');
                return false;
            }
        }

        $("legend.alert").css("display", "none");
        event.preventDefault();
        var form = $("#myform");
        form.validate({
            errorElement: 'span',
            errorClass: 'help-block',
            highlight: function(element, errorClass, validClass) {
                $(element).closest('.form-group').addClass("has-error");
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).closest('.form-group').removeClass("has-error");
            },
            rules: {
                username: {
                    required: true,
                    usernameRegex: true,
                },
                password: {
                    required: true,
                },
                conf_password: {
                    required: true,
                    equalTo: '#password',
                },
                company: {
                    required: true,
                },
                url: {
                    required: true,
                },
                name: {
                    required: true,
                },
                email: {
                    required: true,
                    minlength: 5,
                },
                first_name: {
                    required: true,
                },
                phone_number: {
                    required: true,
                },
                mailing_add: {
                    required: true,
                },
                dob: {
                    required: true,
                },
                city: {
                    required: true,
                },
                state: {
                    required: true,
                },
                zipcode: {
                    required: true,
                },
                country: {
                    required: true,
                },
                hear_about_us: {
                    required: true,
                },
            },
            messages: {
                username: {
                    required: "Please check term and condition",
                },
                password: {
                    required: "Password required",
                },
                conf_password: {
                    required: "Confirm Password required",
                    equalTo: "Password don't match",
                },
                name: {
                    required: "Name required",
                },
                email: {
                    required: "Email required",
                },
                first_name: {
                    required: "User's First Name required",
                },
                phone_number: {
                    required: "Phone number required",
                },
                mailing_add: {
                    required: "Mailing address required",
                },
                dob: {
                    required: "Date of Birth required",
                },
                city: {
                    required: "User's City required",
                },
                state: {
                    required: "User's State required",
                },
                zipcode: {
                    required: "User's Zip Code required",
                },
                country: {
                    required: "User's Country Code required",
                },
                hear_about_us: {
                    required: "Please select one option",
                },
            }
        });
        if (form.valid() === true) {
            var currentURL = window.location.href;
            var token = currentURL.split('?')[1];
            jQuery('#loadingmessage').show();
            addToCart();
            /* var url = 'https://cybersify.tech/smwsa/swapp/check_redeem_gift';
             jQuery.ajax({
                 type: "POST",
                 url: url,
                 data: {
                     "acttoken": token
                 },
                 success: function(results) {
                     setTimeout(function() {
                         var variationIDD = '31307027054656';
                         jQuery.post('/cart/update.js', 'updates[' + variationIDD + ']=0');
                         var returnCInfo = results.NonFormValue;
                         var updateProduCT = jQuery.post('/cart/add.js', {
                             quantity: 1,
                             id: 31307027054656,
                             properties: {
                                 'frequency_num': '1',
                                 'frequency_type': '1',
                                 'frequency_type_text': 'Year(s)',
                                 'group_id': '119336',
                                 '_ro_discount_percentage': '0',
                                 '_ro_unformatted_price': '0',
                                 'discounted_price': '0',
                                 '_ro_unformatted_price': '0'
                             }
                         });
                         console.log('suc')
                         addToCart();

                         if ($('#account_information').is(":visible")) {
                             current_fs = $('#account_information');
                             next_fs = $('#user_account');
                             jQuery('li.second').addClass('active');
                         } else if ($('#user_account').is(":visible")) {
                             current_fs = $('#user_account');
                             next_fs = $('#conf_your_info');
                             jQuery('li.third').addClass('active');
                         }
                         next_fs.show();
                         current_fs.hide();

                     }, 2000);

                 },
                 error: function(results) {
                     console.log(results);
                     var variationIDD = '31307027054656';
                     jQuery.post('/cart/update.js', 'updates[' + variationIDD + ']=0');
                     var updateProduCT = jQuery.post('/cart/add.js', {
                         quantity: 1,
                         id: 31307027054656,
                         properties: {
                             'frequency_num': '1',
                             'frequency_type': '1',
                             'frequency_type_text': 'Year(s)',
                             'group_id': '119336',
                             '_ro_discount_percentage': '0',
                             '_ro_unformatted_price': '0',
                             'discounted_price': '0',
                             '_ro_unformatted_price': '0'
                         }
                     });
                     setTimeout(function() {
                         jQuery('#loadingmessage').hide();
                         var responce = JSON.parse(results.responseText);
                         Swal.fire({
                             icon: 'error',
                             title: 'Oops...',
                             text: responce.message
                         });
                         // addToCart();
                     }, 2000);
                 }
             });*/

            /****** Set Attr Value *********/
            var serializeData = $('#myform').serialize();
            var fName = $('input[name=first_name]').val();
            var lName = $('input[name=last_name]').val();
            var useremaIL = $('input[name=email]').val();
            var user_addresS = $('input[name=mailing_add]').val();
            var phonenumBER = $('input[name=phone_number]').val();
            var birthdAY = $('input[name=dob]').val();
            $('#user_namE').text(fName + ' ' + lName);
            $('#user_emaiL').text(useremaIL);
            $('#user_addres').text(user_addresS);
            $('#phone_num').text(phonenumBER);
            $('#bithdate').text(birthdAY);

            jQuery.getJSON('/cart.js', function(cart) {
                var cartIems = cart.items;
                //console.log(cart)
                if (cartIems.length > 0) {
                    var subTotal = cart.items_subtotal_price - 4900;
                    var total_price = cart.total_price - 4900;
                    $('#total').text(Shopify.formatMoney(subTotal));
                    $('#sub_total').text(Shopify.formatMoney(total_price));
                    $('#sub_total1').text(Shopify.formatMoney(total_price));
                }
            });
            var productData = JSON.parse(localStorage.getItem("products_key"));

            /****** Start Update Basket ***********/
            setTimeout(function() {
                jQuery.getJSON('/cart.js', function(cart) {
                    console.log(cart.token);
                    var cartToken = cart.token;
                    var rucringUrl = 'https://recurringcheckout.com/s/smwsa-dev-v1/checkout/recurring/' + cartToken + '?shop_url=smwsa-dev-v1.myshopify.com';
                    jQuery('a.cart-count.contain-count span.bag-count').text(cart.item_count);
                    setTimeout(function() {
                        jQuery('#myform').attr('action', 'https://recurringcheckout.com/s/smwsa-dev-v1/checkout/recurring/' + cartToken + '?shop_url=smwsa-dev-v1.myshopify.com');
                        if (cart.item_count > 0) {
                            //console.log(cart.item_count);
                        } else {
                            $("legend.alert").css("display", "block");
                        }
                    }, 5000);
                });
            }, 1000);
            /****** End Update Basket ***********/

            var ifName = $('input[name=first_name]').val();
            var ifEmail = $('input[name=email]').val();
            var ifPassword = $('input[name=password]').val();
            var ifConPassword = $('input[name=conf_password]').val();
            var ifaddress = $('input[name=address]').val();
            var ifcity = $('input[name=city]').val();
            var ifstate = $('input[name=state]').val();
            var ifzipcode = $('input[name=zipcode]').val();
            var ifvariationsId = $('input[name=shopify_variations_id]').val();
            var proprizE = $('#pro_price').val();
            var productData = JSON.parse(localStorage.getItem("products_key"));
            if (ifName != '' && ifEmail != '' && ifPassword != '' && ifConPassword != '' && ifaddress != '' && ifcity != '' && ifstate != '' && ifzipcode != '' && ifvariationsId != '') {
                //                 jQuery.post('/cart/add.js', {
                //                     quantity: 1,
                //                     id: 31735744331820,
                //                     properties: {
                //                         'frequency_num': '1',
                //                         'frequency_type': '5',
                //                         'frequency_type_text': 'Year(s)',
                //                         'group_id': '124591',
                //                         '_ro_discount_percentage': '0',
                //                         '_ro_unformatted_price': 99
                //                     }
                //                 });
            }


            //             if ($('#account_information').is(":visible")) {
            //                 current_fs = $('#account_information');
            //                 next_fs = $('#user_account');
            //                 jQuery('li.second').addClass('active');
            //             } else if ($('#user_account').is(":visible")) {
            //                 current_fs = $('#user_account');
            //                 next_fs = $('#conf_your_info');
            //                 jQuery('li.third').addClass('active');
            //             }
            //             next_fs.show();
            //             current_fs.hide();

        }
    });

    $('#previous').click(function() {
        if ($('#account_information').is(":visible")) {
            current_fs = $('#account_information');
            next_fs = $('#membership_product');
        } else if ($('#user_account').is(":visible")) {
            current_fs = $('#user_account');
            next_fs = $('#personal_information');
        }
        next_fs.show();
        current_fs.hide();
    });


    function addToCart() {
        jQuery('#loadingmessage').show();
        setTimeout(function() {
            var currentURL = window.location.href;
            var token = currentURL.split('?')[1];
            var url = 'https://cybersify.tech/smwsa/swapp/redeem_submit';
            jQuery.ajax({
                type: "POST",
                url: url,
                data: $('#myform').serialize() + '&NonFormValue='+token,
                success: function(results) {
                    setTimeout(function() {


                        var variationIDD = '31735744331820';
                        jQuery.post('/cart/update.js', 'updates[' + variationIDD + ']=0');
                        var returnCInfo = results.NonFormValue;
                        var updateProduCT = jQuery.post('/cart/add.js', {
                            quantity: 1,
                            id: 31735744331820,
                            properties: {
                                'frequency_num': '1',
                                'frequency_type': '1',
                                'frequency_type_text': 'Year(s)',
                                'group_id': '124616',
                                '_ro_discount_percentage': '0',
                                '_ro_unformatted_price': '0',
                                'discounted_price': '0',
                                '_ro_unformatted_price': '0'
                            }
                        });

                        if ($('#account_information').is(":visible")) {
                            current_fs = $('#account_information');
                            next_fs = $('#user_account');
                            jQuery('li.second').addClass('active');
                        } else if ($('#user_account').is(":visible")) {
                            current_fs = $('#user_account');
                            next_fs = $('#conf_your_info');
                            jQuery('li.third').addClass('active');
                        }
                        next_fs.show();
                        current_fs.hide();




                        //var responce = JSON.parse(results.responseText);
                        jQuery('#loadingmessage').hide();
                        Swal.fire({
                            icon: 'success',
                            title: 'You successfully registered on SMWSA',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }, 2000);
                },
                error: function(results) {
                    setTimeout(function() {

                        var variationIDD = '31735744331820';
                        jQuery.post('/cart/update.js', 'updates[' + variationIDD + ']=1');
                        var returnCInfo = results.NonFormValue;
                        var updateProduCT = jQuery.post('/cart/add.js', {
                            quantity: 1,
                            id: 31735744331820,
                            properties: {
                                'frequency_num': '1',
                                'frequency_type': '1',
                                'frequency_type_text': 'Year(s)',
                                'group_id': '124616',
                                '_ro_discount_percentage': '0',
                                '_ro_unformatted_price': '0',
                                'discounted_price': '0',
                                '_ro_unformatted_price': '0'
                            }
                        });


                        jQuery('#loadingmessage').hide();
                        var responce1 = JSON.stringify(results.responseText);
                        console.log(responce1)
                        if (responce1 == '""') {
                            if ($('#account_information').is(":visible")) {
                                current_fs = $('#account_information');
                                next_fs = $('#user_account');
                                jQuery('li.second').addClass('active');
                            } else if ($('#user_account').is(":visible")) {
                                current_fs = $('#user_account');
                                next_fs = $('#conf_your_info');
                                jQuery('li.third').addClass('active');
                            }
                            next_fs.show();
                            current_fs.hide();
                        } else {
                            var responce = JSON.parse(results.responseText);
                            Swal.fire({
                                icon: 'error',
                                title: 'Error..!',
                                text: responce.message
                            });
                        }
                    }, 2000);
                }
            });
        }, 2000);
    }

});
/***********EndMultiStep*************/